import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Carousel, CarouselWrapper, CarouselNavigation } from '@codex/organisms';
import UnstyledItem from './Item/index';

const Item = styled(UnstyledItem)``;

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  
  ${Item} {
    width: 50%;
    overflow: hidden;
  }
  
  ${Item} + ${Item} {
    margin-left: ${({ theme }) => theme.spacing[2]};
  }
  
  @media ${({ theme }) => theme.breakpoints.wrapItems} {
    flex-direction: column;
    
    ${Item} {
      width: 100%;
    }
    
    ${Item} + ${Item} {
      margin-left: 0;
      margin-top: ${({ theme, inCarousel }) => (inCarousel ? 0 : theme.spacing[2])};
      position: ${({ inCarousel }) => (inCarousel ? 'absolute' : 'static')};
    }
  }
  
  ${CarouselWrapper} {
    border: ${({ theme }) => `1px solid ${theme.colors.shades[5]}`};
    background-color: ${({ theme }) => theme.colors.shades[7]};
  }
  
  ${CarouselNavigation} {
    margin-left: ${({ theme }) => theme.spacing[2]};
    margin-right: ${({ theme }) => theme.spacing[2]};
  }
`;

const RecentlySaved = (props) => {
  const inCarousel = props.deviceType === 'mobile' && props.items.length > 1;
  const Container = inCarousel ? Carousel : Fragment;

  return (
    <Wrapper inCarousel={inCarousel} className={props.className}>
      <Container>
        {props.items.map(item => (
          <Item
            appearance={inCarousel ? 'in-carousel' : 'box'}
            key={item.name}
            noRatingsLabel={props.noRatingsLabel}
            {...item}
          />
        ))}
      </Container>
    </Wrapper>
  );
};

RecentlySaved.propTypes = {
  className: PropTypes.string,
  deviceType: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  noRatingsLabel: PropTypes.string
};

RecentlySaved.defaultProps = {
  className: undefined,
  deviceType: undefined,
  items: [],
  noRatingsLabel: undefined
};

/** @component */
export default RecentlySaved;
